import axios from 'axios';
import { req } from './axiosFun';



export const campList = (params) => { return axios.get("/customer/listClz") };
export const campListSave  = (params) => { return req("post", "/customer/addClz", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteClz", params) };








// WEBPACK FOOTER //
// ./src/api/campsMG15.js